import { constants } from 'lib_ui-services';
import padMarkText from './padMarkText';

export default {
    verb: 'willMark',
    namespace: 'item',
    relation: 'item',
    description: 'Left pad markText to the tag length this tenant uses',
    //PALM has its own rule, because those tags are not always the full 8 characters
    useCaseIds: [constants.useCaseIds.FLAIR],
    logic: willMark
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: Array<{result:Array<object>}>;
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
function willMark({ data, context }) {
    const paddedMarkText = padMarkText(data?.markText, context);
    if (paddedMarkText === data?.markText) return data;

    data.originalMarkText = data.markText;
    data.markText = paddedMarkText;
    return data;
}
